import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Users, Phone, Mail } from "lucide-react";
import { Link } from "wouter";
import SEOHead from "@/components/SEOHead";

// Store membership categories and fees for future form use - KEEP THIS DATA
// @ts-ignore - keeping for future use
const membershipCategories = [
  {
    type: "Ordinary Member",
    description: "Member + partner & children under 12 yrs",
    entranceFee: "R2,145.84",
    annualFee: "R8,583.36",
    features: ["Full club privileges", "Partner included", "Children under 12 included", "Voting rights"],
    popular: true
  },
  {
    type: "Social Member",
    description: "Limited to 48 days per year",
    entranceFee: "-",
    annualFee: "R5,312.60",
    features: ["48 days per year", "Club facilities access", "Social events", "Restaurant privileges"]
  },
  {
    type: "Intermediate Member",
    description: "Single person 19 to 25 years",
    entranceFee: "-",
    annualFee: "R2,145.84",
    features: ["Age 19-25 years", "Single person only", "Full club privileges", "Special events"]
  },
  {
    type: "Junior Member",
    description: "Birth to 18 years",
    entranceFee: "-",
    annualFee: "R1.00",
    features: ["Birth to 18 years", "Training programs", "Junior sailing", "Family connection required"]
  },
  {
    type: "Crew Visitor",
    description: "Visiting crew members",
    entranceFee: "-",
    annualFee: "R2,145.84",
    features: ["Visiting sailors", "Short-term membership", "Club facilities", "Skipper sponsorship required"]
  },
  {
    type: "Associate Membership",
    description: "As per the Constitution",
    entranceFee: "-",
    annualFee: "R2,634.92",
    features: ["Special circumstances", "Constitutional provisions", "Limited privileges", "Committee approval"]
  }
];

export default function Membership() {
  return (
    <>
      <SEOHead 
        title="Membership - Vaal Cruising Association | Join VCA Today"
        description="Join the Vaal Cruising Association - South Africa's premier boating club. Membership options for all ages and experience levels on the beautiful Vaal Dam."
      />
      <div className="min-h-screen bg-gradient-to-b from-blue-50 to-white">
        {/* Hero Section */}
        <div className="bg-gradient-to-r from-blue-600 to-blue-800 text-white py-16">
          <div className="max-w-6xl mx-auto px-4 text-center">
            <Users className="h-16 w-16 mx-auto mb-4 text-blue-200" />
            <h1 className="text-4xl md:text-5xl font-bold mb-4">Join VCA</h1>
            <p className="text-xl md:text-2xl text-blue-100 mb-8 max-w-3xl mx-auto">
              Become part of South Africa's premier sailing community on the beautiful Vaal Dam
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link href="/apply">
                <Button size="lg" className="bg-orange-500 hover:bg-orange-600 text-white px-8 py-3 text-lg">
                  Apply for Membership
                </Button>
              </Link>
              <Button variant="outline" size="lg" className="bg-white/10 border-white/20 text-white hover:bg-white/20 px-8 py-3 text-lg">
                <Phone className="h-5 w-5 mr-2" />
                Contact Us
              </Button>
            </div>
          </div>
        </div>

        <div className="max-w-6xl mx-auto px-4 py-12">
          {/* Contact Section */}
          <section className="text-center">
            <Card className="bg-gradient-to-r from-orange-50 to-red-50 border-orange-200">
              <CardContent className="p-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">Ready to Join?</h2>
                <p className="text-gray-600 mb-6 max-w-2xl mx-auto">
                  Start your sailing journey with the Vaal Cruising Association. Apply online or contact us for more information.
                </p>
                <div className="flex flex-col sm:flex-row gap-4 justify-center">
                  <Link href="/apply">
                    <Button size="lg" className="bg-orange-500 hover:bg-orange-600 text-white px-8 py-3">
                      Apply Online Now
                    </Button>
                  </Link>
                  <div className="flex flex-col sm:flex-row gap-2 items-center">
                    <Button variant="outline" size="lg" className="px-8 py-3">
                      <Phone className="h-4 w-4 mr-2" />
                      083 446 9474
                    </Button>
                    <Button variant="outline" size="lg" className="px-8 py-3">
                      <Mail className="h-4 w-4 mr-2" />
                      info@vaalcruising.co.za
                    </Button>
                  </div>
                </div>
              </CardContent>
            </Card>
          </section>
        </div>
      </div>
    </>
  );
}